<div class="cart-price-and-actions-block-wrapper">
  <app-item-payment-totals [standalone]="false" [itemGroups]="false" [order]="order"></app-item-payment-totals>
  <div class="seperator mb-14-px"></div>
  @if(!order?.discounts || order?.discounts?.length == 0){
  <app-coupon-code-input [showPaymentMethods]="true"></app-coupon-code-input>
  }
  <div class="actions mt-14-px">
    <button [routerLink]="['/cart']" (click)="closeCartSidenav()" pButton pRipple class="c-button light w-100">
      <span>View cart</span></button>
    <button [disabled]="!order || order?.lines?.length == 0" [routerLink]="['/checkout']" (click)="closeCartSidenav()"
      pButton pRipple class="c-button green w-100"> <span>Checkout</span><img class="ml-8-px"
        src="./../../../../assets/images/icons/arrow-right-white.svg" alt="proceed-to-checkout"> </button>
  </div>
</div>
